module.exports = __webpack_public_path__ + "static/img/upmood-mass.684ed47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/upmood-mass.png
// module id = XDha
// module chunks = 3